import { useEffect } from "react";
import { useColumnSelectionContext } from "../context/useColumnSelectionContext.js";
import { useColumns } from "../context/useColumnsContext.js";
import { useTableScroller } from "../context/useTableScroller.js";
const useColumnSelectionFocus = () => {
  const { focusedColumn, setFocusedColumn } = useColumnSelectionContext();
  const { columnValueToIndex } = useColumns();
  const { scrollToItem } = useTableScroller();
  useEffect(() => {
    if (!focusedColumn || !columnValueToIndex)
      return;
    const columnIndex = columnValueToIndex[focusedColumn];
    if (columnIndex !== void 0) {
      scrollToItem(void 0, columnIndex);
    }
  }, [focusedColumn, columnValueToIndex, scrollToItem]);
  useEffect(() => {
    const handleMessage = (e) => {
      if (e.origin !== window.location.origin)
        return;
      if (e.data.type === "FIELD_MENTION_CLICKED") {
        setFocusedColumn(e.data.field);
        const columnIndex = columnValueToIndex[e.data.field];
        if (columnIndex !== void 0) {
          scrollToItem(void 0, columnIndex);
        }
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [setFocusedColumn, columnValueToIndex, scrollToItem]);
};
export {
  useColumnSelectionFocus
};
